import classNames from 'classnames';
import { UI, Utils } from 'common';
import React from 'react';
import DeleteContactsModal from './DeleteContactsModal.component';

const { WrappedSplitButton, WrappedButtonType } = UI;
const { withLayoutAndModalContexts } = Utils;

const ContactsDetailsHeader = ({
	headerText,
	selectedContacts,
	deleteContacts,
	onPrintPostageClick,
	modalContext: { showModal },
	layoutContext: { collapseSidePanel },
}) => {
	const renderMenuitem = item => {
		const className = classNames('p-menuitem-link', {
			'p-disabled': item.disabled,
		});
		const label = item.label && (
			<span className="p-menuitem-text">{item.label}</span>
		);
		const content = (
			<a
				href={item.url || '#'}
				role="menuitem"
				className={className}
				onClick={item.command}
				aria-label={item.label}
				data-qa={item.dataqa}
				{...{ dataqa: item.dataqa }}
			>
				{label}
			</a>
		);

		return <span>{content}</span>;
	};
	const items = [
		{
			label: 'Delete',
			dataqa:
				selectedContacts.length === 1
					? 'details-panel-more-options-delete'
					: 'multiple-contacts-more-options-delete',
			command: () => {
				showModal({
					component: DeleteContactsModal,
					data: {
						selectedContacts,
						deleteContacts,
					},
				});
			},
		},
		{
			label: 'Collapse Panel',
			dataqa:
				selectedContacts.length === 1
					? 'details-panel-more-options-collapse-panel'
					: 'multiple-contacts-more-options-collapse-panel',
			command: () => {
				collapseSidePanel('East');
			},
		},
	];

	if (selectedContacts.length === 1) {
		items.unshift({
			label: 'Print Postage',
			dataqa: 'details-panel-more-options-print-postage',
			command: () => {
				onPrintPostageClick();
			},
		});
	}

	const renderedMenuItems = items.map(item => {
		item.template = renderMenuitem(item);
		return item;
	});

	return (
		<div className="header">
			<div className="user-icon" />
			<div className="header-text">{headerText}</div>
			<WrappedSplitButton
				icon="more-icon"
				buttonType={WrappedButtonType.Icon}
				model={renderedMenuItems}
				tooltip="Click to see more options"
				tooltipOptions={{
					position: 'bottom',
				}}
				dataqa="contact-details-menu"
			/>
		</div>
	);
};

export default withLayoutAndModalContexts(ContactsDetailsHeader);
